import { Grid } from '@mui/material';
import EditableText from '../../Form/EditableText';
import Utils from '../../../utils/Utils';
import BlockProps from '../../../models/BlockProps';
import BlockTextData from './BlockTextData';

function BlockText({
  data, isEditing, isTemplate, editHandler,
}: BlockProps) {
  const props = (data.data as BlockTextData);
  const handleUpdate = (text?: string) => {
    props.text.value = text;
    editHandler(data.id, { ...props });
  };

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        minHeight: '250px',
        padding: 1.5,
        overflow: 'hidden',
      }}
    >

      {props.text && (
        <Grid
          item
          sx={[Utils.hoverBorder(isEditing), {
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            width: '100%',
          }]}
        >

          <EditableText
            text={props.text.value}
            isEditable={isEditing && !isTemplate}
            updateHandler={handleUpdate}
          />

        </Grid>
      )}

    </Grid>
  );
}

export default BlockText;
